import { z } from 'zod'
import { AuditPropsSchema } from '../common'
import { TinyUserSchema } from '../entity'
import { ProgramIdSchema, UserIdSchema } from '../ids'
import { TinyProgramSchema } from './program'

export const PROGRAM_USER_STATUSES = ['active', 'completed', 'pending', 'dropped'] as const
export const ProgramUserStatusSchema = z.enum(PROGRAM_USER_STATUSES)
export type ProgramUserStatus = z.infer<typeof ProgramUserStatusSchema>

export const UnsavedProgramUserSchema = z.object({
  userId: UserIdSchema.optional().meta({ deprecated: true }),
  programId: ProgramIdSchema,
  startDate: z.number().optional(),
})
export type UnsavedProgramUser = z.infer<typeof UnsavedProgramUserSchema>

export const ProgramUserDataSchema = z.object({
  ...AuditPropsSchema.shape,
  ...UnsavedProgramUserSchema.required({ startDate: true }).shape,
  userId: UserIdSchema,
  completionDate: z.number().optional(),
  status: ProgramUserStatusSchema,
  droppedDate: z.number().optional().describe('Date the user dropped the program, if applicable'),
  user: TinyUserSchema,
  program: TinyProgramSchema,
})
export type ProgramUserData = z.infer<typeof ProgramUserDataSchema>

export const ProgramUserWithProgramSchema = z.object({
  ...ProgramUserDataSchema.shape,
  program: TinyProgramSchema,
})
export type ProgramUserWithProgram = z.infer<typeof ProgramUserWithProgramSchema>
